import z from "zod";

export const zUploadResult = z.object({
  name: z.string(),
  path: z.string(),
});
export type ZUploadResult = z.infer<typeof zUploadResult>;
